const closeButtonLabel = "Cerrar";
const esUS = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  esUS as default
};
